export const toastGutter = 8

export const durationToMillisecondsMapping = {
    short: 3000,
    medium: 6000,
    long: 12000,
    infinity: Infinity,
}
